import React from 'react'
import AboutImage from '../img/about2.svg'

const About = () =>{
    return(
      <>
        <h1 className="text-5xl mt-16 text-center font-bold max-md:text-5xl max-md:text-center max-sm:text-4xl">ABOUT US</h1>
        <section className="px-6 py-1" id="about">
          <div className="flex flex-row max-md:text-center max-[1000px]:flex-col-reverse">
            <div className="w-1/2 flex align-middle justify-center mt-5 max-[1100px]:mt-10 max-[1000px]:mt-5  max-[1000px]:w-full">
            <img src={AboutImage} alt="about"  className='w-full max-[1000px]:w-3/4'/>
            </div>
            <div className="right" class=" w-1/2 mt-10 flex align-middle justify-center p-4 max-[1000px]:p-8 max-[1000px]:text-center max-[1000px]:w-full max-[900px]:mt-6 max-[1200px]:mt-0">
              <p className="text-lg mt-7 text-[#3d3d3d] leading-[45px] text-justify px-5 max-[900px]:mt-2 max-[900px]:px-2 max-sm:text-base max-sm:leading-[40px]">
                Kirche consultants is a civil engineering consulting firm that
                carries out designs for structures, dams, water and sewerage
                systems, and roads. In addition to carrying out designs, the
                consultancy also carries out Environmental Impact
                Assessment reports and feasibility studies. The firm has in-
                depth knowledge in water supplies including studies for
                unaccounted for water.
              </p>
            </div>
          </div>
        </section>
      </>
    )

}

export default About